<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="after-the-bombs-the-cavemen-1">
<h1>After the Bombs: The Cavemen</h1>
<p>As they watched from the safety of the trees, the cavemen saw Andrew and Mel come along on horseback. The cavemen did not fancy their chances with a horse none of them had ever ridden a horse before and they were more than a little afraid of them. Plus, the riders didn’t appear to have any food with them they so the cavemen had no interest in Andrew and Mel.</p>
<p>Behind the trees where the cavemen hid, the River Calder ran between Calder City and Fort Calder.</p>
<p>There were bushes near the river and they were covered in berries. The berries tasted fine and the cavemen stood picking and eating them.</p>
<p>It wasn’t much of a meal but it was keeping them alive. While they were picking and eating berries, they did not see Jonah and Celeste arrive and talk to Andrew and Mel.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch019.vue?1b3f57c8